import { useConfig } from "../state";
import { HitLink } from "./HitLink";

const mapping = {
  name: "Kavelnaam",
  area: "Oppervlakte m²",
  zone_1: "Provincie",
  zone_2: "Gemeente",
  land_cover: "Huidig gebruik",
  nnn: "NatuurNetwerk",
  natura_2000: "Natura 2000",
  arch_monuments: "Archeologische verwachting",
};
const KeyVal = ({ k, children }) =>
  !children ? null : (
    <div className="p-0.5">
      <span className="w-32 inline-block italic">{k}</span> {children}
    </div>
  );
export const ListHit = ({ hit }) => {
  const config = useConfig();
  return (
    <HitLink hit={hit}>
      <div className="w-32 lg:w-52 flex-item">
        <img
          src={`${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=170&height=170`}
          srcSet={`${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=170&height=170 1x, ${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=340&height=340 2x`}
          className="w-full border-2 border-solid border-gray-300 rounded-lg"
          alt={hit.name}
        />
      </div>
      <div className="flex-item pl-2">
        <KeyVal k="Adres">{hit.addresses?.[0]}</KeyVal>
        {Object.entries(mapping).map(([key, label], index) => (
          <KeyVal key={index} k={label}>
            {hit[key]}
          </KeyVal>
        ))}
      </div>
    </HitLink>
  );
};
